import { useEffect } from "react";
import "../css/userProfile.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { postReset, setViewCreatePostModal } from "../features/posts/postSlice";
import MyPostFeed from "../components/MyPostFeed";
import ChoosePostPage from "../components/postComponents/ChoosePostPage";
import { logout, resetUser } from "features/auth/authSlice";
import styled from "styled-components";
import AddIcon from "@mui/icons-material/Add";
import {
  PageWrapper,
  PageContainerMain,
  UserProfileMain,
  StyledSideBar,
} from "./pages.styled";
import Sidebar from "components/Sidebar";
import ExtraSidebar from "components/sidebar/Sidebar";
import { useTranslation } from "react-i18next";

function MyProfile() {
  const { t } = useTranslation("feed");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { isError, message } = useSelector((state) => state.profile);
  const { isPostError, postsMessage } = useSelector((state) => state.posts);

  useEffect(() => {
    if (user.isOrganization) {
      navigate(`/${user.username}`);
    }

    if (isPostError && postsMessage === "Not logged in") {
      navigate("/login");
      dispatch(logout());
      dispatch(resetUser());
      window.location.reload(false);
    }

    if (isError) {
      toast.error(message);
    }

    if (!user) {
      navigate("/login");
    }
  }, [user, isError, message, dispatch, navigate, isPostError, postsMessage]);

  useEffect(() => {
    return () => {
      dispatch(postReset());
    };
  }, []);

  return (
    <PageWrapper>
      <PageContainerMain>
        <div className="churchProfileLeft">
          <Sidebar />
        </div>
        <UserProfileMain>
          <MyProfileTop1>
            <ChoosePostPage />

            <CreatePostBtnMPT1
              onClick={() => dispatch(setViewCreatePostModal(true))}
            >
              <span>{t("composer.createPost")}</span> <AddIcon />
            </CreatePostBtnMPT1>
          </MyProfileTop1>

          <MyPostFeed name={"user"} />
        </UserProfileMain>

        <StyledSideBar>
          <ExtraSidebar />
        </StyledSideBar>
      </PageContainerMain>
    </PageWrapper>
  );
}

export default MyProfile;

const MyProfileTop1 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: fit-content;
  /* border: 1px solid green; */
  margin-bottom: 0px;
  justify-content: flex-start;
  /* padding: 10px 10px 0px 10px; */
  width: 100%;

  padding: 10px;

  @media (max-width: 768px) {
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
  }
`;
const CreatePostBtnMPT1 = styled.div`
  display: none;
  color: white;
  border-radius: 15px;
  padding: 10px 20px;
  background-color: var(--themeColor);
  width: fit-content;
  height: 40px;
  white-space: nowrap;
  font-size: smaller;
  span {
    margin-right: 5px;
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
